module.exports = __webpack_public_path__ + "static/media/default_wakatuki_ren_update5cee835e5f104f2ccae12f9979bf14d1.webp";